export default __webpack_public_path__ + "media/Jason-Cradit-desktop.7c8f4248.jpg";